import React, { useEffect, useState, useRef } from 'react';
import { MapPin, Search, TrendingUp, X, SlidersHorizontal, ChevronDown } from 'lucide-react';
export function Clubs() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [locationSearch, setLocationSearch] = useState('');
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const locationRef = useRef<HTMLDivElement>(null);
  const locations = ['Boston, MA', 'Boulder, CO', 'New York, NY', 'Miami, FL', 'Chicago, IL', 'Seattle, WA', 'Los Angeles, CA', 'San Francisco, CA', 'Austin, TX', 'Denver, CO'];
  const filteredLocations = locations.filter(loc => loc.toLowerCase().includes(locationSearch.toLowerCase()));
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (locationRef.current && !locationRef.current.contains(event.target as Node)) {
        setShowLocationDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const clubs = [{
    id: 1,
    name: 'City Striders',
    location: 'Boston, MA',
    type: 'Road Running',
    size: 'Medium (21-50)',
    description: 'A community of urban runners focused on road racing and weekly group runs through the city.',
    image: 'https://images.unsplash.com/photo-1571008887538-b36bb32f4571?w=800&h=500&fit=crop&auto=format&q=80'
  }, {
    id: 2,
    name: 'Mountain Goats',
    location: 'Boulder, CO',
    type: 'Trail Running',
    size: 'Small (1-20)',
    description: "Trail running enthusiasts exploring Colorado's best mountain paths and challenging terrain.",
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=800&h=500&fit=crop&auto=format&q=80'
  }, {
    id: 3,
    name: 'Urban Runners',
    location: 'New York, NY',
    type: 'Social',
    size: 'Large (51-100)',
    description: 'Social running club bringing together runners of all levels for fun and fitness in the city.',
    image: 'https://images.unsplash.com/photo-1483721310020-03333e577078?w=800&h=500&fit=crop&auto=format&q=80'
  }, {
    id: 4,
    name: 'Coastal Track Club',
    location: 'Miami, FL',
    type: 'Track & Field',
    size: 'Medium (21-50)',
    description: "Track and field athletes training together on Miami's coastal paths and professional facilities.",
    image: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800&h=500&fit=crop&auto=format&q=80'
  }, {
    id: 5,
    name: 'Marathon Training Group',
    location: 'Chicago, IL',
    type: 'Competitive',
    size: 'Very Large (100+)',
    description: 'Dedicated marathon runners following structured training plans to achieve their race goals.',
    image: 'https://images.unsplash.com/photo-1513593771513-7b58b6c4af38?w=800&h=500&fit=crop&auto=format&q=80'
  }, {
    id: 6,
    name: 'Early Birds',
    location: 'Seattle, WA',
    type: 'Social',
    size: 'Medium (21-50)',
    description: "Morning runners who start their day with energizing sunrise runs through Seattle's neighborhoods.",
    image: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=800&h=500&fit=crop&auto=format&q=80'
  }];
  const filteredClubs = clubs.filter(club => {
    const matchesSearch = searchQuery === '' || club.name.toLowerCase().includes(searchQuery.toLowerCase()) || club.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesLocation = selectedLocation === '' || club.location === selectedLocation;
    return matchesSearch && matchesLocation;
  });
  const handleLocationSelect = (location: string) => {
    setSelectedLocation(location);
    setLocationSearch(location);
    setShowLocationDropdown(false);
  };
  const clearLocation = () => {
    setSelectedLocation('');
    setLocationSearch('');
  };
  const activeFiltersCount = (searchQuery ? 1 : 0) + (selectedLocation ? 1 : 0);
  return <div className="w-full bg-gray-50 min-h-screen pb-20" data-id="element-579">
      {/* Banner */}
      <div className="relative h-[300px] sm:h-[400px] overflow-hidden" data-id="element-580">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1920&h=400&fit=crop&auto=format&q=80)'
      }} data-id="element-581">
          <div className="absolute inset-0 bg-gradient-to-r from-[#0E578E]/95 via-[#0E578E]/90 to-[#01AAE7]/85" data-id="element-582"></div>
        </div>

        <div className="absolute inset-0" data-id="element-583">
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }} data-id="element-584"></div>
        </div>

        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-center" data-id="element-585">
          <div className="text-center max-w-3xl" data-id="element-586">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-6 border border-white/30 shadow-lg" data-id="element-587">
              <TrendingUp className="h-3.5 sm:h-4 w-3.5 sm:w-4" data-id="element-588" />
              {filteredClubs.length} Clubs Available
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-3 sm:mb-4 leading-tight drop-shadow-lg px-4" data-id="element-589">
              Running Clubs Near You
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-white/95 leading-relaxed max-w-2xl mx-auto drop-shadow-md px-4" data-id="element-590">
              Find your tribe. Connect with local running communities and train
              together.
            </p>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0" data-id="element-591">
          <svg viewBox="0 0 1440 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-592">
            <path d="M0 48H1440V24C1440 24 1200 0 720 0C240 0 0 24 0 24V48Z" fill="#F9FAFB" data-id="element-593" />
          </svg>
        </div>
      </div>

      {/* Filter Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 mt-6 sm:mt-8" data-id="element-594">
        {/* Mobile: Filter Icon Button */}
        <div className="lg:hidden mb-6" data-id="element-595">
          <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="relative w-full flex items-center justify-between gap-3 px-5 py-4 bg-white rounded-xl shadow-lg border-2 border-gray-200 hover:border-[#01AAE7] transition-all" data-id="element-596">
            <div className="flex items-center gap-3" data-id="element-597">
              <div className="w-10 h-10 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] rounded-lg flex items-center justify-center" data-id="element-598">
                <SlidersHorizontal className="h-5 w-5 text-white" data-id="element-599" />
              </div>
              <div className="text-left" data-id="element-600">
                <div className="text-sm font-bold text-gray-900" data-id="element-601">
                  Filters & Search
                </div>
                <div className="text-xs text-gray-500" data-id="element-602">
                  {activeFiltersCount > 0 ? `${activeFiltersCount} active` : 'Tap to filter'}
                </div>
              </div>
            </div>
            <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${showMobileFilters ? 'rotate-180' : ''}`} data-id="element-603" />
            {activeFiltersCount > 0 && <span className="absolute -top-2 -right-2 bg-[#01AAE7] text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center shadow-lg" data-id="element-604">
                {activeFiltersCount}
              </span>}
          </button>

          {/* Mobile Filter Dropdown */}
          {showMobileFilters && <div className="mt-4 bg-white rounded-xl shadow-xl border border-gray-200 p-5 space-y-4" data-id="element-605">
              {/* Search */}
              <div className="relative" data-id="element-606">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 z-10" data-id="element-607" />
                <input type="text" placeholder="Search clubs..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-900 transition-all" data-id="element-608" />
              </div>

              {/* Location */}
              <div className="relative" ref={locationRef} data-id="element-609">
                <MapPin className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 z-10" data-id="element-610" />
                <input type="text" placeholder="Location" value={locationSearch} onChange={e => {
              setLocationSearch(e.target.value);
              setShowLocationDropdown(true);
              if (e.target.value === '') {
                setSelectedLocation('');
              }
            }} onFocus={() => setShowLocationDropdown(true)} className="w-full pl-12 pr-10 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-900 transition-all" data-id="element-611" />
                {selectedLocation && <button onClick={clearLocation} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 z-10" data-id="element-612">
                    <X className="h-4 w-4" data-id="element-613" />
                  </button>}

                {showLocationDropdown && locationSearch && filteredLocations.length > 0 && <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-xl shadow-xl z-50 max-h-60 overflow-y-auto" data-id="element-614">
                      {filteredLocations.map(location => <button key={location} onClick={() => handleLocationSelect(location)} className="w-full text-left px-4 py-3 hover:bg-blue-50 transition-colors text-gray-700 text-sm border-b border-gray-100 last:border-b-0 flex items-center gap-2" data-id="element-615">
                          <MapPin className="h-4 w-4 text-gray-400" data-id="element-616" />
                          {location}
                        </button>)}
                    </div>}
              </div>

              {/* Apply Button */}
              <div className="flex gap-3 pt-3 border-t border-gray-200" data-id="element-617">
                {activeFiltersCount > 0 && <button onClick={() => {
              setSearchQuery('');
              setSelectedLocation('');
              setLocationSearch('');
            }} className="flex-1 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-xl transition-all" data-id="element-618">
                    Clear All
                  </button>}
                <button onClick={() => setShowMobileFilters(false)} className="flex-1 px-4 py-3 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg" data-id="element-619">
                  Apply Filters
                </button>
              </div>
            </div>}
        </div>

        {/* Desktop: Full Filter Bar */}
        <div className="hidden lg:block bg-white rounded-xl sm:rounded-2xl shadow-xl border border-gray-100 p-4 sm:p-5 mb-8 sm:mb-10" data-id="element-620">
          <div className="flex flex-col lg:flex-row gap-3 items-stretch lg:items-center" data-id="element-621">
            <div className="relative flex-1" data-id="element-622">
              <Search className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 h-4 sm:h-5 w-4 sm:w-5 text-gray-400 z-10" data-id="element-623" />
              <input type="text" placeholder="Search clubs..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 sm:pl-12 pr-4 py-2.5 sm:py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-900 transition-all text-sm sm:text-base" data-id="element-624" />
            </div>

            <div className="relative lg:w-48" ref={locationRef} data-id="element-625">
              <MapPin className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 h-4 sm:h-5 w-4 sm:w-5 text-gray-400 z-10" data-id="element-626" />
              <input type="text" placeholder="Location" value={locationSearch} onChange={e => {
              setLocationSearch(e.target.value);
              setShowLocationDropdown(true);
              if (e.target.value === '') {
                setSelectedLocation('');
              }
            }} onFocus={() => setShowLocationDropdown(true)} className="w-full pl-10 sm:pl-12 pr-10 py-2.5 sm:py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-900 transition-all text-sm sm:text-base" data-id="element-627" />
              {selectedLocation && <button onClick={clearLocation} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 z-10" data-id="element-628">
                  <X className="h-4 w-4" data-id="element-629" />
                </button>}

              {showLocationDropdown && locationSearch && filteredLocations.length > 0 && <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-xl shadow-xl z-50 max-h-60 overflow-y-auto" data-id="element-630">
                    {filteredLocations.map(location => <button key={location} onClick={() => handleLocationSelect(location)} className="w-full text-left px-4 py-3 hover:bg-blue-50 transition-colors text-gray-700 text-sm border-b border-gray-100 last:border-b-0 flex items-center gap-2" data-id="element-631">
                        <MapPin className="h-4 w-4 text-gray-400" data-id="element-632" />
                        {location}
                      </button>)}
                  </div>}
            </div>

            <button className="px-6 sm:px-8 py-2.5 sm:py-3 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl lg:w-auto text-sm sm:text-base" data-id="element-633">
              Search
            </button>
          </div>

          <div className="flex items-center mt-4 pt-4 border-t border-gray-100" data-id="element-634">
            <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-500 font-medium" data-id="element-635">
              <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-636"></div>
              <span data-id="element-637">Showing {filteredClubs.length} results</span>
            </div>
          </div>
        </div>

        {/* Clubs Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-638">
          {filteredClubs.length > 0 ? filteredClubs.map(club => <div key={club.id} className="group relative rounded-xl sm:rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-[#01AAE7] transition-all duration-300" style={{
          backgroundColor: '#FCFCFD'
        }} data-id="element-639">
                <div className="h-40 sm:h-48 relative overflow-hidden bg-gray-200" data-id="element-640">
                  <img src={club.image} alt={club.name} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-641" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-642"></div>
                </div>

                <div className="p-5 sm:p-6" data-id="element-643">
                  <h3 className="text-lg sm:text-xl font-black text-gray-900 mb-2 sm:mb-3 group-hover:text-[#0E578E] transition-colors leading-tight" data-id="element-644">
                    {club.name}
                  </h3>

                  <p className="text-gray-600 text-xs sm:text-sm mb-3 sm:mb-4 line-clamp-2 leading-relaxed" data-id="element-645">
                    {club.description}
                  </p>

                  <div className="flex items-center gap-2 text-gray-600 mb-4 sm:mb-6" data-id="element-646">
                    <MapPin className="h-3.5 sm:h-4 w-3.5 sm:w-4 text-gray-400 flex-shrink-0" data-id="element-647" />
                    <span className="text-xs sm:text-sm font-medium" data-id="element-648">
                      {club.location}
                    </span>
                  </div>

                  <button className="w-full text-white bg-gradient-to-r from-[#01AAE7] to-[#0199d6] rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 py-3 sm:py-3.5 px-4 font-bold text-sm sm:text-base" data-id="element-649">
                    View Club
                  </button>
                </div>
              </div>) : <div className="col-span-full text-center py-12 sm:py-16" data-id="element-650">
              <div className="text-gray-400 mb-4" data-id="element-651">
                <Search className="h-12 sm:h-16 w-12 sm:w-16 mx-auto mb-4" data-id="element-652" />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2" data-id="element-653">
                No clubs found
              </h3>
              <p className="text-sm sm:text-base text-gray-500 mb-4" data-id="element-654">
                Try adjusting your search filters
              </p>
            </div>}
        </div>
      </div>
    </div>;
}